import { humanizeValidationErrors, makeValidatorFn } from './validator-util';
import * as moment from 'moment';
export var TOO_MANY_CHARS = 'tooManyCharacters';
export var ILLEGAL_CHARS = 'illegalCharacters';
export var FORMAT_MISMATCH = 'formatMismatch';
export var PASSWORD_FORMAT_MISMATCH = 'passwordFormatMismatch';
export var PASSWORD_MISMATCH = 'passwordMismatch';
export var REQUIRED = 'required';
export var EMAIL = 'email';
export var VALIDATORS = [
    TOO_MANY_CHARS,
    ILLEGAL_CHARS,
    FORMAT_MISMATCH,
    PASSWORD_FORMAT_MISMATCH,
    PASSWORD_MISMATCH,
    REQUIRED,
    EMAIL
];
var ValidationResult = /** @class */ (function () {
    function ValidationResult() {
    }
    return ValidationResult;
}());
export { ValidationResult };
var ValidatorFactories = /** @class */ (function () {
    function ValidatorFactories() {
    }
    /**
     * Creates a validator for dates based on a date format e.g. dd-MM-yyyy
     * @param dateFormat The date format to compare, default: dd-MM-yyyy.
     * @param extension A custom validator extension function.
     */
    ValidatorFactories.date = function (dateFormat, extension) {
        var format = dateFormat || 'dd-MM-yyyy';
        return makeValidatorFn(function (value) {
            var _a;
            if (!moment(value, format).isValid())
                return _a = {}, _a[FORMAT_MISMATCH] = { value: value }, _a;
            return {};
        }, extension);
    };
    /**
     * Creates a validator for passwords, based on the specified checks.
     * @param minLength The minimum length for a password
     * @param needsSpecial Specifies whether a password should contain special character
     * @param needsUpper Specifies whether a password should contain a upper character.
     * @param needsNumber Specifies whether a password should contain a alphanumeric character
     * @param extension A custom validator extension function.
     */
    ValidatorFactories.password = function (minLength, needsSpecial, needsUpper, needsLower, needsNumber, extension) {
        if (minLength === undefined)
            minLength = 6;
        if (needsSpecial === undefined)
            needsSpecial = true;
        if (needsUpper === undefined)
            needsUpper = true;
        if (needsLower === undefined)
            needsLower = true;
        if (needsNumber === undefined)
            needsNumber = true;
        return makeValidatorFn(function (value) {
            var _a, _b, _c, _d, _e;
            if (needsUpper && !/[A-Z]/.test(value))
                return _a = {}, _a[PASSWORD_FORMAT_MISMATCH] = { value: value }, _a;
            if (needsLower && !/[a-z]/.test(value))
                return _b = {}, _b[PASSWORD_FORMAT_MISMATCH] = { value: value }, _b;
            if (needsSpecial && !/[!@#$%^&*()_\-+=|\\'";:<>/?{}\[\].]/.test(value))
                return _c = {}, _c[PASSWORD_FORMAT_MISMATCH] = { value: value }, _c;
            if (needsNumber && !/[0-9]/.test(value))
                return _d = {}, _d[PASSWORD_FORMAT_MISMATCH] = { value: value }, _d;
            if (value.length < minLength)
                return _e = {}, _e[PASSWORD_FORMAT_MISMATCH] = { value: value }, _e;
            return {};
        }, extension);
    };
    /**
     * Creates a validator that checks whether the original password input
     * is equal to the repeat password.
     * @param originalControl The control containing the original password
     */
    ValidatorFactories.repeatPassword = function (originalControl) {
        return makeValidatorFn(function (value) {
            var _a;
            if (originalControl.value !== value)
                return _a = {}, _a[PASSWORD_MISMATCH] = { value: value }, _a;
            return {};
        });
    };
    /**
     * Creates a reference field validator which checks max length and special characters.
     * @param maxLength The maximum length of the field.
     * @param extension A custom validator extension function.
     */
    ValidatorFactories.reference = function (maxLength, extension) {
        return makeValidatorFn(function (value) {
            var _a, _b;
            var allowedLength = maxLength || 25;
            if (value && value.length > allowedLength)
                return _a = {}, _a[TOO_MANY_CHARS] = { value: value, params: { length: allowedLength } }, _a;
            var results = (value || '').match(/[!@#$%^&*()_\-\+=\|\\\[\]\/\<\>\.]/g);
            if (results && results.length)
                return _b = {}, _b[ILLEGAL_CHARS] = { value: value, params: {
                        chars: results.reduce(function (joined, curr) { return joined.indexOf(curr) === -1 ? joined === '' ? curr : (joined + ', ' + curr) : joined; })
                    } }, _b;
        }, extension);
    };
    /**
     * Creates a dynamic validator based on the input validator function.
     * @param validator The validator function used for validation.
     */
    ValidatorFactories.dynamic = function (validator) {
        return makeValidatorFn(validator);
    };
    return ValidatorFactories;
}());
export { ValidatorFactories };
var ValidationTranslation = /** @class */ (function () {
    function ValidationTranslation() {
    }
    /**
     * Fetches all validation errors for the control
     * and humanizes them according to specified translations.
     * @param control The control to retrieve validation errors from.
     * @param translations The translations to use for any errors.
     */
    ValidationTranslation.humanizeErrors = function (control, translations, fieldMap) {
        return humanizeValidationErrors(control, translations, fieldMap);
    };
    /**
     * Directly extracts all distinct error messages.
     * @param errors {@link TranslatedErrors} value to directly extract all distinct messages from.
     */
    ValidationTranslation.distinctMessages = function (errors) {
        return Object.keys(errors).reduce(function (messages, controlName) {
            Object.keys(errors[controlName]).forEach(function (errorName) {
                var message = errors[controlName][errorName];
                if (messages.indexOf(message) === -1)
                    messages.push(message);
            });
            return messages;
        }, []);
    };
    /**
     * Directly extracts all error messages.
     * @param errors {@link TranslatedErrors} value to directly extract all messages from.
     */
    ValidationTranslation.messages = function (errors) {
        return Object.keys(errors).reduce(function (messages, controlName) {
            Object.keys(errors[controlName]).forEach(function (errorName) { return messages.push(errors[controlName][errorName]); });
            return messages;
        }, []);
    };
    return ValidationTranslation;
}());
export { ValidationTranslation };
